module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "signup"
    }
  }, [_c('h1', [_vm._v("Question, suggestion?")]), _vm._v(" "), _c('p', [_vm._v("Drop me a line.")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://formspree.io/maryse.camelan@gmail.com",
      "method": "POST",
      "id": "mG61Hd2",
      "target": "_self"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "_next",
      "value": "//mc3.co/Lumiere/#/contact"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "Text",
      "placeholder": "Name",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "name": "Email",
      "jsname": "L9xHkb",
      "placeholder": "Email",
      "required": ""
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "Message",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "submit"
    }
  }, [_vm._v("Submit")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eac07828","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact.vue
// module id = 49
// module chunks = 0